module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/shopping/wallet-f68bdc8734ec5482a18a07eeec7d6a37.svg";